import * as _ from "lodash"
import { ServiceQuote } from "@requests"

export interface IHasBaseServiceQuoteObject {
    getBaseServiceQuoteObject(): ServiceQuote | undefined
    setBaseServiceQuoteObject(baseQuoteObject: ServiceQuote): void
}

function hasBaseServiceQuoteObject<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasBaseServiceQuoteObject {
        private baseServiceQuoteObject: ServiceQuote | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getBaseServiceQuoteObject(): ServiceQuote | undefined {
            return this.baseServiceQuoteObject
        }
        public setBaseServiceQuoteObject(baseServiceQuoteObject: ServiceQuote): void {
            this.baseServiceQuoteObject = _.cloneDeep(baseServiceQuoteObject)
        }
    };
}

export default hasBaseServiceQuoteObject